<template lang="pug">
	.end-card-control
		small.not-supported.text-muted(v-if="!Creative.SelectedCreative.Tags.pixi") This creative don't support new End Cards
		.supported(v-if="Creative.SelectedCreative.Tags.pixi")
			.end-card-icon(v-if="endCard" :style="getVersionScreenshotStyles(endCard)")
			small.no-end-card-message.text-muted(v-if="!endCard") No End Card specified. Native playable End Card will be used if exist.
			.end-card-message(v-if="endCard") {{endCard.title}}
			.buttons
				button.btn.btn-sm.btn-outline-primary.change(type="button" v-on:click="openEndCardSelector()")
					i.fa.fa-navicon
					span(v-if="endCard") Change
					span(v-else) Select
				button.btn.btn-sm.btn-outline-secondary.edit(v-if="endCard" type="button" v-on:click="showEndCard(endCard)")
					i.fa.fa-eye
					| Toggle
				button.btn.btn-sm.btn-outline-secondary.edit(v-if="endCard" type="button" v-on:click="editEndCard(endCard)")
					i.fa.fa-edit
					| Edit

</template>

<script>

	import Screen 				from './../../../mixins/screen';

	import { Creative } 			from './../../../services/Creative';
	import { Settings } 		from './../../../services/Settings';
	import { Version } 			from './../../../services/Version';

	export default {
		name: "EndCardControl",
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Version Switched",
				"Selected Version Fully Loaded",
				"Selected Version Setting Changed:end-card-version-id",
				"Settings Tab Changed:templates"
			]
		},
		props: ['setting'],
		data() {

			this.Creative = Creative;
			this.Settings = Settings;

			this.endCard = null;

			return {
				showed: true
			}

		},
		methods: {
			collectData() {

				if (!Version.SelectedVersion || !this.setting || !Settings.isSettingExist(this.setting.codename)) return console.log('EndCardControl collectData FAILED', this.setting?.['codename'], Version.SelectedVersion?.id, this.setting?.['version_id']);

				this.endCard = Version.getVersion(Settings.getSettingValue(this.setting.codename));

			},
			openEndCardSelector() {

				Broadcast.call("Show EndCardSelector");

			},
			getVersionScreenshotStyles(endCard) {

				return {
					backgroundImage: Version.getVersionScreenshot(Creative.getCreative(endCard['creative_id']), endCard)
				};

			},
			showEndCard() {

				Broadcast.call("Send To iFrame", [{ToggleEndCard: true}]);

			},
			editEndCard(endCard) {

				window.localStorage.setItem(Version.getStoredVersionKey(endCard['creative_id']), endCard['id']);

				Creative.selectCreative(endCard['creative_id']);

			}
		}
	}
</script>

<style lang="sass">

	.end-card-control
		display: flex
		flex-direction: column
		position: relative

		.end-card-icon
			position: absolute
			top: -25px
			right: 0
			height: calc(1920px / 15)
			width: calc(1080px / 15)
			background-size: contain
			background-repeat: no-repeat

		.end-card-message
			color: #20a8d8
			margin-top: 10px
			margin-bottom: 28px

		& > small
			margin-top: 10px
			margin-bottom: 10px

		.buttons
			display: flex
			flex-direction: row
			flex-wrap: nowrap

			button
				text-align: left

				i
					margin-right: 10px

			button.edit
				margin-left: 10px

</style>
